<template>

  <table class="table table-condensed table-hover m-0">
    <tbody>
    <tr>
      <td>B-Item</td>
      <td>3 Days</td>
      <td class="font-weight-bold">
        {{getDueDate(3)}}
      </td>
    </tr>
    <tr>
      <td>C-Item</td>
      <td>10 Days</td>
      <td class="font-weight-bold">
        {{getDueDate(10)}}
      </td>
    </tr>
    <tr>
      <td>D-Item</td>
      <td>120 Days</td>
      <td class="font-weight-bold">
        {{getDueDate(120)}}
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
  import { Component, Vue } from "vue-property-decorator";
  import { DateTime } from "luxon";

  @Component
  export default class MocDueDateCalculator extends Vue {
    getDueDate(days: number): string
    {
      const date = DateTime.utc();
      const due = date.plus({ days: days});
      return due.toFormat('dd.MM.yyyy');
    }
  }
</script>

<style lang="scss">
</style>
